import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');

const propTypes = {
    inputId: PropTypes.string,
    className: PropTypes.string,
    activityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    activityLocked: PropTypes.bool.isRequired,
    channelUserPermissions: PropTypes.object,
    projectUserPermissions: PropTypes.object
};

const defaultProps = {
    inputId: 'act-play-text',
    className: '',
    channelUserPermissions: {},
    projectUserPermissions: {}
};

class ActivityPlayButtonTextEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activityStoreState: ActivityStore.getStateActivity(props.activityId, props.projectId, props.channelId),
            playText: '',
            resumeText: '',
            playTextClean: true,
            playTextUpdateActionId: null
        };

        this.setPlayText = this.setPlayText.bind(this);
        this.setResumeText = this.setResumeText.bind(this);
        this.updatePlayText = this.updatePlayText.bind(this);

        this.unsubscribes = [ActivityStore.listen(this.onActivityStoreStateChange.bind(this))];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onActivityStoreStateChange(newState) {
        let updatedState = { activityStoreState: ActivityStore.getStateActivity(this.props.activityId, this.props.projectId, this.props.channelId) };

        if (newState.action.id === this.state.playTextUpdateActionId) {
            updatedState = { ...updatedState, playTextClean: true, playTextUpdateActionId: null };
        }

        this.setState(updatedState);
    }

    setPlayText(e) {
        this.setState({ playText: e.target.value, playTextClean: false });
    }

    setResumeText(e) {
        this.setState({ resumeText: e.target.value, playTextClean: false });
    }


    updatePlayText() {
        const actionId = uuid.v4();
        this.setState({ playTextUpdateActionId: actionId }, () => {
            ActivityActions.setPlayTextActivity(actionId, {
                activityID: this.props.activityId,
                projectID: this.props.projectId,
                playText: this.state.playText.toString(),
                resumeText: this.state.resumeText.toString(),
            });
        });
    }

    render() {
        if (!this.state.activityStoreState.activity) {
            return null;
        }

        const storeActivity = this.state.activityStoreState.activity;
        if (!storeActivity) {
            return null;
        }

        const actPlayText = this.state.playTextClean ? (storeActivity.meta_data.playText || ''): this.state.playText;
        const actResumeText = this.state.playTextClean ? (storeActivity.meta_data.resumeText || ''): this.state.resumeText;
        const canEditActivity = PermissionsUtil.canEditActivity(this.props.channelUserPermissions, this.props.projectUserPermissions);

        return (
            <div className={this.props.className}>
                <input
                    id={this.props.inputId}
                    className="actEditMetaDataInput margin-bottom-md"
                    value={actPlayText}
                    placeholder={Strings['en'].activity.play_button.PB_PLACEHOLDER}
                    disabled={this.state.activityLocked || !canEditActivity}
                    onChange={this.setPlayText}
                />
                <input
                    id={this.props.inputId+'_resumeText'}
                    className="actEditMetaDataInput margin-bottom-md"
                    value={actResumeText}
                    placeholder={Strings['en'].activity.play_button.RB_PLACEHOLDER}
                    disabled={this.state.activityLocked || !canEditActivity}
                    onChange={this.setResumeText}
                />
                { canEditActivity &&
                    <button
                        className="btn btn-primary block"
                        onClick={this.updatePlayText}
                        disabled={this.state.playTextClean || !!this.state.playTextUpdateActionId || this.props.activityLocked}
                    >
                        {Strings['en'].common.UPDATE}
                    </button>
                }
            </div>
        );
    }
}

ActivityPlayButtonTextEditor.propTypes = propTypes;
ActivityPlayButtonTextEditor.defaultProps = defaultProps;

export default ActivityPlayButtonTextEditor;